import { api, getIdentity, setIdentity } from "./api";
import { dancerHasDanceDetails } from "./dancerProfile";

export function isDancerProfileIncomplete(profile) {
  return !dancerHasDanceDetails(profile);
}

function persistIdentityFromDancer(dancer, local) {
  if (!dancer?.id) return;
  setIdentity({
    dancer_id: dancer.id,
    name: dancer.name || local?.name || "",
    role: dancer.role || local?.role || "",
    dance_forms: dancer.dance_forms || local?.dance_forms || [],
  });
}

/**
 * After sign-in, link the guest dancer_id to the signed-in account (via phone)
 * and push any locally-known profile fields that are missing on the server.
 */
export async function syncGuestProfileAfterSignIn(organizer) {
  const local = getIdentity();
  let dancerId = local?.dancer_id || null;

  if (!dancerId && organizer?.phone) {
    try {
      const r = await api.get(`/dancers/by-phone/${encodeURIComponent(organizer.phone)}`);
      if (r.data.found && r.data.dancer?.id) {
        dancerId = r.data.dancer.id;
      }
    } catch {
      // no linked dancer yet
    }
  }

  if (!dancerId) return { dancerId: null, synced: false, profile: null };

  let remote = null;
  try {
    const r = await api.get(`/dancers/${dancerId}`);
    remote = r.data;
  } catch {
    return { dancerId, synced: false, profile: null };
  }

  const patch = {};
  const localName = (local?.name || organizer?.name || "").trim();
  const localRole = local?.role || "";
  const localForms = local?.dance_forms || [];

  if (!remote.name?.trim() && localName) patch.name = localName;
  if (!remote.role && localRole) patch.role = localRole;
  if (!(remote.dance_forms || []).length && localForms.length) {
    patch.dance_forms = localForms;
  }
  if (organizer?.phone && remote.phone !== organizer.phone) {
    patch.phone = organizer.phone;
  }

  if (!Object.keys(patch).length) {
    persistIdentityFromDancer(remote, local);
    return { dancerId, synced: false, profile: remote };
  }

  const r = await api.patch(`/dancers/${dancerId}`, patch);
  persistIdentityFromDancer(r.data, local);
  return { dancerId, synced: true, profile: r.data };
}
